export const pagesProductsEn = {
  add: {
    backButton: 'Back',
    documentTitle: 'Add Product',
    fields: {
      code: 'Code',
      name: 'Name',
      objective: 'Objective',
      owner: 'Owner',
      publishScope: 'Publish Scope',
      publishStatus: 'Publish Status'
    },
    nextButton: 'Next',
    pageTitle: 'Add Product',
    placeholders: {
      code: 'e.g. PRD-001',
      name: 'e.g. Atlas',
      objective: 'What problem does this product solve?',
      owner: 'Select an owner'
    },
    progressbar: {
      filled: 'Filled',
      modeSetting: 'Input Mode',
      mustItem: 'Required Items',
      mustItemOnly: 'Required fields only',
      progressCircle: 'Progress Circle',
      title: 'Progress',
      total: 'All Items'
    },
    sections: {
      basicInfo: 'Basic Information',
      owner: 'Owner',
      publishSettings: 'Publish Settings'
    },
    stepper: {
      basicInfo: 'Basic Information',
      owner: 'Owner',
      publishSettings: 'Publish Settings',
      title: 'Sections'
    },
    submitButton: 'Create',
    toast: {
      error: 'Failed to create product',
      success: 'Product created'
    },
    validation: {
      required: 'Required'
    }
  },
  addSelect: {
    csvBulkUpload: 'Bulk upload via CSV',
    externalSystemSync: 'Sync with external system',
    fillOutDetails: 'Fill out details',
    methods: {
      csv: {
        inDevelopmentTag: 'In Development'
      },
      externalSystemSync: {
        inDevelopmentTag: 'In Development'
      }
    },
    orLabel: 'Or...',
    pageTitle: 'Add Product',
    productCardTitle: 'Product',
    requiredFields: {
      name: 'Name',
      objective: 'Objective',
      publishScope: 'Publish Scope'
    },
    requiredItems: 'Required items',
    selectionTitle: 'How would you like to add the product?'
  },
  detail: {
    breadcrumb: {
      home: 'Home',
      products: 'Products'
    },
    devDocuments: {
      columns: {
        code: 'Code',
        kind: 'Kind',
        status: 'Status',
        title: 'Title',
        updatedAt: 'Updated At'
      },
      noResults: 'No development documents belong to this product.',
      searchPlaceholder: 'Search by title or code'
    },
    fields: {
      dependencies: 'Dependencies',
      featureFlag: 'Feature Flag',
      firstReleaseDate: 'First Release Date',
      id: 'ID',
      name: 'Name',
      objective: 'Objective',
      owner: 'Owner',
      publishScope: 'Publish Scope',
      status: 'Status',
      type: 'Type',
      updateCount: 'Update Count',
      updatedAt: 'Last Updated'
    },
    header: {
      labels: {
        firstRelease: 'First Release',
        latestRelease: 'Latest Release',
        updateCount: 'Updates: {{count}}',
        updatedAt: 'Updated: {{date}}'
      },
      ownerNotSet: 'Owner not set'
    },
    kind: {
      FUNCTION: 'Function',
      MODULE: 'Module',
      PRODUCT: 'Product',
      SUB_MODULE: 'Sub-module'
    },
    pageTitle: 'Product Details',
    pmfLevel: {
      hint: 'Optional. Leave it unset until you can judge.',
      label: 'PMF Level',
      options: {
        LV0: 'Lv0',
        LV1: 'Lv1',
        LV2: 'Lv2',
        LV3: 'Lv3'
      },
      toast: {
        error: 'Failed to update PMF level',
        success: 'PMF level updated'
      },
      unset: 'Not set'
    },
    productScope: {
      addButton: 'Add',
      addDisabledHint: 'Switch to the "All" tab to add a row to the top level.',
      addHint: 'Add a row at the top level (directly under the product).',
      changeButton: 'Edit',
      noResults: "No features are included in this product's scope.",
      removeConfirm: {
        description: 'Delete {{count}} node(s)? This action cannot be undone.',
        title: 'Delete Nodes'
      },
      table: {
        headers: {
          kind: 'Type',
          name: 'Name',
          publishStatus: 'Publish Status'
        },
        kind: {
          FUNCTION: 'Function',
          MODULE: 'Module',
          PRODUCT: 'Product',
          SPECIFICATION: 'Specification',
          SUB_MODULE: 'Sub Module'
        }
      },
      toast: {
        success: 'Product scope updated'
      }
    },
    productions: {
      columns: {
        description: 'Description',
        plannedReleaseDate: 'Planned Release',
        releaseLevel: 'Level',
        releaseName: 'Version',
        releasedAt: 'Released At',
        status: 'Status'
      },
      noResults: 'No productions belong to this product.',
      searchPlaceholder: 'Search by version...'
    },
    realizingValue: {
      noResults: 'No values are realized by this feature.',
      table: {
        headers: {
          code: 'No.',
          confidence: 'Confidence',
          layer: 'Layer',
          status: 'Status',
          targetBusiness: 'Business',
          targetUser: 'User',
          title: 'Title'
        },
        layer: {
          COMPANY_WIDE: 'Company-wide',
          EXECUTIVE: 'Executive',
          MANAGER: 'Manager',
          OPERATOR: 'Operator'
        }
      }
    },
    repositories: {
      addRepository: 'Add Repository',
      defaultBranchLabel: 'Branch',
      defaultBranchPlaceholder: 'develop',
      empty: 'No repositories linked',
      loadFailed: 'Failed to load repository links',
      loading: 'Loading repository links…',
      removeRepository: 'Remove repository',
      role: {
        BACKEND: 'Backend',
        FRONTEND: 'Frontend',
        MONOREPO: 'Monorepo'
      },
      rolePlaceholder: 'Select a role',
      sectionTitle: 'Source Repositories',
      toast: {
        success: 'Repository links updated'
      },
      topSection: 'Repository Links',
      urlLabel: 'Repository URL',
      urlPlaceholder: 'https://github.com/org/repo',
      validation: {
        urlDuplicate: 'Repository URLs must be unique',
        urlRequired: 'Enter a repository URL'
      }
    },
    subSections: {
      basicInfo: 'Basic Info'
    },
    tabs: {
      detail: 'Detail',
      devDocuments: 'Development Documents',
      history: 'History',
      productScope: 'Product Scope',
      productions: 'Productions',
      profile: 'Profile',
      value: 'Realizing Values'
    },
    toast: {
      success: 'Product updated'
    },
    topSections: {
      basicInfo: 'Basic Info'
    },
    trackerLinks: {
      addTrackerLink: 'Add Tracker',
      empty: 'No trackers linked',
      kind: {
        JIRA: 'Jira',
        LINEAR: 'Linear',
        NOTION: 'Notion'
      },
      kindPlaceholder: 'Select a tracker',
      loadFailed: 'Failed to load tracker links',
      loading: 'Loading tracker links…',
      noteLabel: 'Note',
      notePlaceholder: 'Mapping hint for AI (optional)',
      removeTrackerLink: 'Remove tracker',
      sectionTitle: 'External Trackers',
      targetRefLabel: 'Target Reference',
      targetRefPlaceholder: 'e.g. Notion database ID',
      toast: {
        success: 'Tracker links updated'
      },
      topSection: 'Tracker Links',
      urlLabel: 'Tracker URL',
      urlPlaceholder: 'https://www.notion.so/...',
      validation: {
        duplicate: 'The combination of tracker and target reference must be unique',
        targetRefRequired: 'Enter a target reference',
        urlRequired: 'Enter a tracker URL'
      }
    },
    updateCountFormat: '{{count}} times'
  },
  list: {
    addProduct: 'Add Product',
    filterPlaceholder: 'Search products...',
    noResults: 'No matching products found.',
    pageTitle: 'Products',
    publishEnded: {
      noResults: 'No unpublished products.',
      pageTitle: 'Published Ended',
      tabLabel: 'Published Ended'
    },
    publishScope: {
      internal: 'Internal Only',
      none: 'Private',
      public: 'Public',
      restricted: 'Restricted'
    },
    publishStatus: {
      inDevelopment: 'In Development',
      published: 'Published',
      unpublished: 'Unpublished'
    },
    tabLabel: 'Product List',
    table: {
      headers: {
        firstReleaseName: 'First Release',
        firstReleasedAt: 'First Released On',
        latestReleaseName: 'Latest Release',
        latestReleasedAt: 'Latest Released On',
        name: 'Name',
        publishScope: 'Publish Scope',
        publishStatus: 'Publish Status'
      }
    },
    tabs: {
      all: 'All'
    }
  },
  targetNodeEditor: {
    done: 'Done',
    dragHandle: 'Drag to move {{name}}',
    empty: 'No nodes found',
    expandTabs: {
      all: 'All',
      module: 'Modules',
      subModule: 'Sub-modules',
      target: 'Targets only'
    },
    searchPlaceholder: 'Search by name',
    toast: {
      moveError: 'Failed to move the item',
      moveSuccess: 'Moved'
    }
  },
  title: 'Products'
};